export const CardDescription: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={"cpln-ant-card-description"}>{children}</div>;
};
